var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBoxSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3672 12.5913C22.3672 7.06846 17.89 2.59131 12.3672 2.59131C6.84434 2.59131 2.36719 7.06846 2.36719 12.5913C2.36719 18.1142 6.84434 22.5913 12.3672 22.5913C17.89 22.5913 22.3672 18.1142 22.3672 12.5913Z",
    stroke: "#141B34",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36719 13.3413C8.36719 13.3413 9.96719 14.2538 10.7672 15.5913C10.7672 15.5913 13.1672 10.3413 16.3672 8.59131",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxSelected);
export default __webpack_public_path__ + "static/media/check-box-selected.d96810cb8a271e52ba9c79959bed1a5a.svg";
export { ForwardRef as ReactComponent };